import { atom } from "recoil";

export const editBrandUserAtomFunc = atom({
  key: '01840496-d222-4581-84ad-584291e2043a', // unique ID (with respect to other atoms/selectors)
  default: {
    btnText: false,

  },
});
